import React from 'react';
import { Switch, Tooltip } from 'antd';
import { MoonOutlined, SunOutlined } from '@ant-design/icons';
import { useTheme } from '../context/ThemeContext';

const ThemeColorPicker = () => {
  const { isDarkMode, toggleDarkMode } = useTheme();

  return (
    <Tooltip title={isDarkMode ? '切换浅色模式' : '切换深色模式'}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
        {isDarkMode ? (
          <MoonOutlined style={{ color: '#fff', fontSize: 14 }} />
        ) : (
          <SunOutlined style={{ color: '#fff', fontSize: 14 }} />
        )}
        <Switch
          size="small"
          checked={isDarkMode}
          onChange={toggleDarkMode}
          checkedChildren="暗"
          unCheckedChildren="亮"
        />
      </div>
    </Tooltip>
  );
};

export default ThemeColorPicker;